import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import 'babel-polyfill'

import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import { notification } from 'antd'
import './index.less'

import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import { createStore, applyMiddleware } from 'redux'
import reducer from './reducer'
import asyncComponent from './async-component'
import http from './api'
import { getRedirectPath } from './utils'

// redux 注入操作
const middleware = [thunk]
const store = createStore(reducer, applyMiddleware(...middleware))

const App = asyncComponent(() => import('./app.js'))
const Login = asyncComponent(() => import('./pages/login/login.jsx'))

/**
 * 初始化应用
 */
async function main() {
  notification.config({
    duration: 5,
    top: 70
  })
  
  // 获取该用户的门店列表，以及默认的第一个门店id
  if (window.localStorage.getItem('token')) {

    let hotels = window.localStorage.getItem('hotels')
    let hotelInfo = window.localStorage.getItem('hotelInfo')
    
    if (hotels && hotelInfo) {
      store.dispatch({
        type: 'HOTELS',
        hotels: JSON.parse(hotels)
      })
      store.dispatch({ 
        type: 'HOTELINFO', 
        hotelInfo: JSON.parse(hotelInfo)
      })
    } else {
      //兼容之前版本, 2020-02-19日开始，门店信息存储到local中,为了兼容之前没有储存到版本，这里进行请求后存储
      try {
      
        let res = await http.getHotelLists({per_page: 9999, current_page: 0})
        if (res.retCode === 21020000) {
          let hotel = res.data[0] || {}
          let info = {...hotel, sourceName: hotel.chain_name, sourceId: hotel.chain_id}
          window.localStorage.setItem('hotels', JSON.stringify(res.data || []))
          window.localStorage.setItem('hotelInfo', JSON.stringify(info))
          store.dispatch({
            type: 'HOTELS',
            hotels: res.data || []
          })
          store.dispatch({ 
            type: 'HOTELINFO', 
            hotelInfo: info 
          })
        }
      } catch (error) {
      }
    }
    
  }

  renderApp()
}

/**
 * 认证路由，如果当前页面需要登录才能访问，改用AuthRoute
 */
export const AuthRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        // 如果有token，允许访问
        const token = window.localStorage.getItem('token')
        if (token) return <Component {...props} />
        // 没token，登录去, superlogin超级管理员登陆界面 login 用户登陆界面
        if (rest.super) return <Redirect to={{ pathname: '/superlogin', from: props.location }} />
        
        return <Redirect to={{ pathname: '/login', from: props.location }} />
      }}
    />
  )
}


const renderApp = () => {
  return new Promise((resolve) => {
    ReactDOM.render(
      <Provider store={store}>
        <BrowserRouter>
          <Switch>
            <Route exact path="/" render={() => <Redirect to={getRedirectPath()} push />} />

            <AuthRoute path="/home" component={App} />
            <Route path="/login" component={Login} />
            <Redirect to={{ pathname: '/' }} />
          </Switch>
        </BrowserRouter>
      </Provider>,
      document.getElementById('root'),
      resolve
    )
  })

}

main()


// WEBPACK FOOTER //
// ./src/index.js